import MUICard, { CardProps } from '@mui/material/Card';

export type { CardProps };

const Card = ({ children, variant = 'outlined', sx, ...otherProps }: CardProps) => (
  <MUICard sx={{ ...sx, borderColor: 'layout.surface.border' }} variant={variant} {...otherProps}>
    {children}
  </MUICard>
);

export default Card;
